import { fabric } from 'fabric';
import ResizeControl, { type ResizeControlOptions } from './ResizeControl';
import { resizeWithSmartGuides } from '../objects/SmartGuideBehaviors';

export interface LinearResizeControlOptions extends ResizeControlOptions {
  edge: string;
}

/**
 * Resize along both axes. This control updates width and height directly, not,
 * scaleX and scaleY like ShapeLinearResizeControl.
 */
class LinearResizeControl extends ResizeControl {
  cursorStyleHandler = fabric.controlsUtils.scaleCursorStyleHandler;
  minDimension = 18;
  edge: string;

  constructor(options: LinearResizeControlOptions) {
    super(options);
    switch (this.edge) {
      case 'top':
        this.x = 0;
        this.y = -0.5;
        break;
      case 'bottom':
        this.x = 0;
        this.y = 0.5;
        break;
      case 'left':
        this.x = -0.5;
        this.y = 0;
        break;
      case 'right':
        this.x = 0.5;
        this.y = 0;
        break;
    }

    // limit this control to only resize one dimension
    let axis;
    if (['top', 'bottom'].includes(this.edge)) {
      this.resizeDimension = 'height';
      axis = 'h';
    } else {
      this.resizeDimension = 'width';
      axis = 'v';
    }

    this.actionHandler = resizeWithSmartGuides(this.actionHandler, [axis]);
  }

  positionHandler(
    dim: { x: number; y: number },
    finalMatrix: any,
    fabricObject: fabric.Object,
    currentControl: fabric.Control
  ): fabric.Point {
    // hook into the position handler to update this controls sizeX and sizeY to cover an
    // entire edge of the bounding box minus a small margin from the corner controls.
    // .sizeX and .sizeY are used to determine the clickable area
    const thickness = fabricObject.cornerSize;
    const touchThickness = fabricObject.touchCornerSize;
    const margin = fabricObject.touchCornerSize;
    const zoom = fabricObject.canvas?.getZoom() || 1;
    if (this.edge === 'left' || this.edge === 'right') {
      this.sizeY = fabricObject.height * fabricObject.scaleY * zoom - margin;
      this.sizeX = thickness;
      this.touchSizeY = this.sizeY;
      this.touchSizeX = touchThickness;
    } else if (this.edge === 'top' || this.edge === 'bottom') {
      this.sizeY = thickness;
      this.sizeX = fabricObject.width * fabricObject.scaleX * zoom - margin;
      this.touchSizeY = touchThickness;
      this.touchSizeX = this.sizeX;
    }
    return super.positionHandler(
      dim,
      finalMatrix,
      fabricObject,
      currentControl
    );
  }

  // Control has no visual representation.
  render() {
    // render(ctx, left, top, styleOverride, fabricObject) {
    // Debug only
    // for (const [c, sX, sY] of [
    //   ['red', this.sizeX, this.sizeY],
    //   ['green', this.touchSizeX, this.touchSizeY],
    // ]) {
    //   ctx.beginPath();
    //   ctx.strokeWidth = 10;
    //   ctx.strokeStyle = c;
    //   ctx.moveTo(left, top);
    //   ctx.moveTo(left - sX / 2, top - sY / 2);
    //   ctx.lineTo(left + sX / 2, top - sY / 2);
    //   ctx.lineTo(left + sX / 2, top + sY / 2);
    //   ctx.lineTo(left - sX / 2, top + sY / 2);
    //   ctx.closePath();
    //   ctx.stroke();
    // }
  }
}

export default LinearResizeControl;
